import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [showInitiativesDropdown, setShowInitiativesDropdown] = useState(false);
  
  // Ref to detect clicks outside the dropdown
  const dropdownRef = useRef(null);
  
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowInitiativesDropdown(false);
      }
    };
    
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <div className="container mx-auto px-4 py-3 relative">
{/* Main header row */}
<div className="flex items-center justify-between w-full">
  {/* Left side with logos - moved to extreme left */}
  <div className="flex items-center flex-shrink-0">
    {/* Logo group - now more compact with smaller images */}
<div className="flex space-x-1 sm:space-x-2 items-center">
  <img src="/images/dept.png" alt="Logo 1" className="h-6 sm:h-7 w-auto" />
  <img src="/images/tnlogo.png" alt="Logo 2" className="h-6 sm:h-7 w-auto hidden sm:block" />
  <img src="/images/dept1.png" alt="Logo 3" className="h-6 sm:h-7 w-auto hidden sm:block" />
  <img src="/images/india.png" alt="Logo 4" className="h-6 sm:h-7 w-auto" />
</div>
  </div>
  
  {/* Title - centered with proper spacing */}
  <div className="hidden sm:block mx-4 md:mx-6 flex-grow text-center">
    <h1 className="text-xs md:text-sm font-semibold text-gray-800 leading-tight">
      Commissionerate of Rural Development and Panchayat Raj (Training)
    </h1>
  </div>

          {/* Mobile Menu Button - now properly positioned */}
          <div className="md:hidden flex items-center">
            <button
              onClick={toggleMenu}
              className="text-gray-600 hover:text-blue-600 focus:outline-none"
              aria-label="Toggle mobile menu"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                {isMenuOpen ? (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                ) : (
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M4 6h16M4 12h16M4 18h16"
                  />
                )}
              </svg>
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center ml-auto">
            <div className="flex items-center space-x-2 xl:space-x-3">
              <Link to="/" className="flex items-center text-gray-700 hover:text-blue-600 transition-colors px-2 py-1">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                </svg>
                <span className="font-medium text-xs">Home</span>
              </Link>
              
              <Link to="/about" className="flex items-center text-gray-700 hover:text-blue-600 transition-colors px-2 py-1">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span className="font-medium text-xs">About Us</span>
              </Link>
              
              {/* Documents Menu Item */}
              <Link to="/documents" className="flex items-center text-gray-700 hover:text-blue-600 transition-colors px-2 py-1">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                </svg>
                <span className="font-medium text-xs">Documents</span>
              </Link>

              {/* Initiatives Menu Item with Dropdown */}
              <div className="relative group" ref={dropdownRef}>
                <button 
                  className="flex items-center text-gray-700 hover:text-blue-600 transition-colors focus:outline-none px-2 py-1"
                  onClick={() => setShowInitiativesDropdown(!showInitiativesDropdown)}
                  onMouseEnter={() => setShowInitiativesDropdown(true)}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                  </svg>
                  <span className="font-medium text-xs">Initiatives</span>
                  <svg 
                    xmlns="http://www.w3.org/2000/svg" 
                    className="h-3 w-3 ml-1" 
                    fill="none" 
                    viewBox="0 0 24 24" 
                    stroke="currentColor"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                </button>
                
                {/* Dropdown content */}
                {showInitiativesDropdown && (
                  <div 
                    className="absolute left-0 mt-2 w-32 bg-white shadow-lg rounded-md py-1 z-50 border border-gray-100"
                    onMouseLeave={() => setShowInitiativesDropdown(false)}
                  >
                    <Link 
                      to="/sird" 
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600"
                      onClick={() => setShowInitiativesDropdown(false)}
                    >
                      SIRD
                    </Link>
                    <Link 
                      to="/rird" 
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-600"
                      onClick={() => setShowInitiativesDropdown(false)}
                    >
                      RIRD
                    </Link>
                  </div>
                )}
              </div>
              
              {/* Schemes Menu Item */}
              <Link to="/schemes" className="flex items-center text-gray-700 hover:text-blue-600 transition-colors px-2 py-1">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
                <span className="font-medium text-xs">Schemes</span>
              </Link>

              {/* Training Modules Menu Item */}
              <Link to="/training-modules" className="flex items-center text-gray-700 hover:text-blue-600 transition-colors px-2 py-1 whitespace-nowrap">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
                </svg>
                <span className="font-medium text-xs">Training Modules</span>
              </Link>

              {/* Login Menu Item */}
              <Link to="/login" className="flex items-center text-gray-700 hover:text-blue-600 transition-colors px-2 py-1">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
                </svg>
                <span className="font-medium text-xs">Login</span>
              </Link>
            </div>
          </nav>
        </div>
        
        {/* Mobile title - only visible on smallest screens */}
        <div className="sm:hidden text-center mt-2">
          <h2 className="text-xs font-semibold text-gray-800">
            Commissionerate of Rural Development and Panchayat Raj (Training)
          </h2>
        </div>

        {/* Mobile Menu - full width, sliding animation */}
        <div 
          className={`md:hidden mt-3 border-t border-gray-100 pt-3 transition-all duration-300 ${
            isMenuOpen ? 'max-h-[500px] opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
          }`}
        >
          <div className="flex flex-col space-y-2">
            <Link 
              to="/" 
              className="flex items-center text-gray-700 hover:text-blue-600 transition-colors px-2 py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
              </svg>
              <span className="font-medium">Home</span>
            </Link>
            
            <Link 
              to="/about" 
              className="flex items-center text-gray-700 hover:text-blue-600 transition-colors px-2 py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              <span className="font-medium">About Us</span>
            </Link>
            
            {/* Documents Mobile Menu Item */}
            <Link 
              to="/documents" 
              className="flex items-center text-gray-700 hover:text-blue-600 transition-colors px-2 py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              <span className="font-medium">Documents</span>
            </Link>
            
            {/* Initiatives Mobile Menu with submenu */}
            <div className="space-y-1">
              <div className="flex items-center text-gray-700 px-2 py-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
                <span className="font-medium">Initiatives</span>
              </div>
              <div className="pl-10 space-y-1">
                <Link 
                  to="/sird" 
                  className="block text-gray-600 hover:text-blue-600 py-1"
                  onClick={() => setIsMenuOpen(false)}
                >
                  SIRD
                </Link>
                <Link 
                  to="/rird" 
                  className="block text-gray-600 hover:text-blue-600 py-1"
                  onClick={() => setIsMenuOpen(false)}
                >
                  RIRD
                </Link>
              </div>
            </div>
            
            {/* Schemes Mobile Menu Item */}
            <Link 
              to="/schemes" 
              className="flex items-center text-gray-700 hover:text-blue-600 transition-colors px-2 py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
              </svg>
              <span className="font-medium">Schemes</span>
            </Link>

            {/* Training Modules Mobile Menu Item */}
            <Link 
              to="/training-modules" 
              className="flex items-center text-gray-700 hover:text-blue-600 transition-colors px-2 py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
              </svg>
              <span className="font-medium">Training Modules</span>
            </Link>

            {/* Login Mobile Menu Item */}
            <Link 
              to="/login" 
              className="flex items-center text-gray-700 hover:text-blue-600 transition-colors px-2 py-2"
              onClick={() => setIsMenuOpen(false)}
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1" />
              </svg>
              <span className="font-medium">Login</span>
            </Link>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;